const bgList = {
  solutions: {
    1920: require('@/assets/backgrounds/cover4-1920.jpg'),
    1024: require('@/assets/backgrounds/cover4-1920.jpg'),
    400: require('@/assets/backgrounds/cover4-1920.jpg')
  },
  services: {
    1920: require('@/assets/backgrounds/cover3-1920.jpg'),
    1024: require('@/assets/backgrounds/cover3-1920.jpg'),
    400: require('@/assets/backgrounds/cover3-1920.jpg')
  },
  home: {
    1920: require('@/assets/backgrounds/cover1-1920.jpg'),
    1024: require('@/assets/backgrounds/cover1-1920.jpg'),
    400: require('@/assets/backgrounds/cover1-1920.jpg')
  },
  greenSpirit: {
    1920: require('@/assets/backgrounds/cover6-1920.jpg'),
    1024: require('@/assets/backgrounds/cover6-1920.jpg'),
    400: require('@/assets/backgrounds/cover6-1920.jpg')
  },
  company: {
    1920: require('@/assets/backgrounds/cover7-1920.jpg'),
    1024: require('@/assets/backgrounds/cover7-1920.jpg'),
    400: require('@/assets/backgrounds/cover7-1920.jpg')
  }
}

export default bgList
